import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";

class MapsListTemplate extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    let uniqueSubtitles = [];
    let mapsBySubtitle = [];

    posts.forEach((post) => {
      let subtitle = post.node.frontmatter.subtitle;
      if (!mapsBySubtitle[subtitle]) {
        mapsBySubtitle[subtitle] = [];
      }
      mapsBySubtitle[subtitle].push(post.node);
    });

    uniqueSubtitles = Object.keys(mapsBySubtitle);

    return (
      <div className="columns is-multiline">
        <div className="column is-6">
          <h2>Moab, Utah Trail Maps:</h2>
          <p>Plan your next trip by browsing popular Moab, Utah MTB trails.</p>
          <div className="content">
            <ul className="no-bullets">
              {mapsBySubtitle &&
                mapsBySubtitle["Moab, Utah Trail Map"] &&
                mapsBySubtitle["Moab, Utah Trail Map"].map((post) => (
                  <li key={post.id}>
                    <Link
                      className="title has-text-primary is-size-4"
                      to={post.fields.slug}
                    >
                      {post.frontmatter.title}
                      {post.frontmatter.subtitle ? (
                        <>, {post.frontmatter.subtitle}</>
                      ) : null}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="column is-6">
          <h2>Moab, Utah Trail Regions:</h2>
          <p>
            Regions are the largest mapped areas. Each region has numerous
            routes and trails.
          </p>
          <div className="content">
            <ul className="no-bullets">
              {mapsBySubtitle &&
                mapsBySubtitle["Moab, Utah Region Map"] &&
                mapsBySubtitle["Moab, Utah Region Map"].map((post) => (
                  <li key={post.id}>
                    <Link
                      className="title has-text-primary is-size-4"
                      to={post.fields.slug}
                    >
                      {post.frontmatter.title}
                      {post.frontmatter.subtitle ? (
                        <>, {post.frontmatter.subtitle}</>
                      ) : null}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
          <h2>Moab, Utah Trail Routes:</h2>
          <p>
            Routes are the second largest mapped areas. Each route has numerous
            trails.
          </p>
          <div className="content">
            <ul className="no-bullets">
              {mapsBySubtitle &&
                mapsBySubtitle["Moab, Utah Route Map"] &&
                mapsBySubtitle["Moab, Utah Route Map"].map((post) => (
                  <li key={post.id}>
                    <Link
                      className="title has-text-primary is-size-4"
                      to={post.fields.slug}
                    >
                      {post.frontmatter.title}
                      {post.frontmatter.subtitle ? (
                        <>, {post.frontmatter.subtitle}</>
                      ) : null}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

MapsList.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function MapsList() {
  return (
    <StaticQuery
      query={graphql`
        query MapsListQuery {
          allMarkdownRemark(
            sort: [
              { frontmatter: { subtitle: DESC } }
              { frontmatter: { title: ASC } }
            ]
            filter: {
              frontmatter: {
                templateKey: { eq: "maps-page" }
                title: { ne: "Maps" }
              }
            }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  subtitle
                }
              }
            }
          }
        }
      `}
      render={(data, count) => <MapsListTemplate data={data} count={count} />}
    />
  );
}
